import React from 'react'
import { Form } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import Access from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestInput = ({ initialValue }) => {
    return (
        <Form.Item label='Input' name='input' rules={[{ required: true, message: 'Please, enter test input' }]}>
            <Access
                rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}
                fallback={<Text>{initialValue}</Text>}
            >
                <TextArea row={4} />
            </Access>
        </Form.Item>
    )
}

export default TestInput
